module.exports = __webpack_public_path__ + "static/media/expired.a33bb5a3.svg";